import createRefresh from "react-auth-kit/createRefresh";
import axios from "axios";

// Fired when a refresh failure requires the app to sign the user out.
// The interceptor hook listens for this event inside the React tree.
export const AUTH_REFRESH_FAILED_EVENT = "auth:refresh-failed";

export const refresh = createRefresh({
  interval: 15,
  refreshApiCallback: async (param) => {
    if (!param.refreshToken) {
      return { isSuccess: false };
    }

    try {
      const verifyGuid = localStorage.getItem("_auth_verify_guid");
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}User/refresh-token/${param.refreshToken}`,
        {
          withCredentials: true,
          params: { guid: verifyGuid || undefined },
          headers: {
            ...(param.authToken && {
              Authorization: `Bearer ${param.authToken}`,
            }),
            "Content-Type": "application/json",
          },
          timeout: 10000,
        },
      );

      if (!response.data?.accessToken) {
        console.error("Refresh - Invalid response structure:", response.data);
        return { isSuccess: false };
      }

      if (response.data.verifyGuid) {
        localStorage.setItem("_auth_verify_guid", response.data.verifyGuid);
      }

      return {
        isSuccess: true,
        newAuthToken: response.data.accessToken,
        newAuthTokenExpireIn: 3600,
        newRefreshToken: response.data.refreshToken,
        newRefreshTokenExpiresIn: 86400,
      };
    } catch (error) {
      console.error("Refresh - Token refresh failed:", {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
      // Server rejected the token — force sign-out so the user is redirected to login
      // instead of being left on a grey, non-functional page.
      // Dispatch on any refresh failure so the app redirects to login instead
      // of leaving the user on a grey, non-functional page. This covers 401/403
      // (server rejected token), network errors (phone woke up mid-request),
      // and 5xx responses.
      window.dispatchEvent(new CustomEvent(AUTH_REFRESH_FAILED_EVENT));

      return { isSuccess: false };
    }
  },
});
